import React from "react";
import ReactSelect from "./ReactSelect";
import { names, ucFirst, unslufigy } from "../../../helpers/StringHelper";

class NewSearchableSelect extends React.Component {
  labelText() {
    let { label, name } = this.props;
    if (label) return label;
    else {
      if (name) {
        let _label = unslufigy(name);
        if (name.includes(`_id`)) _label = ucFirst(name.split(`_id`)[0]);
        return _label;
      }
    }
  }

  render() {
    let {
      name,
      options,
      clearable,
      placeholder,
      errors,
      required,
      processing,
      noFormGroup,
      disabled,
      onChange,
    } = this.props;

    return (
      <div
        className={names(
          !noFormGroup && `form-group`,
          errors && errors.length && `has-error`,
          disabled && `item-disabled`,
          required && `required`,
          processing && `processing`,
        )}
      >
        <ReactSelect
          name={name}
          label={this.labelText()}
          placeholder={placeholder}
          isClearable={clearable}
          isDisabled={disabled}
          onChange={onChange}
          options={options}
          border={1}
          noFormGroup
        />
      </div>
    );
  }
}
export default NewSearchableSelect;
